export default __webpack_public_path__ + "assets/images/onboarding/063fb3fd27acadbc7e852d6725002d46.mp4";